/* eslint-disable @typescript-eslint/no-explicit-any */
import { EventType } from '@azure/msal-browser';
import { AppInsightsContext, AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js';
import Cookies from 'js-cookie';

import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

import { ThemeProvider } from '@mui/material';

import App from '@/App';
import '@/index.css';
import i18next from '@/lib/i18n';
import { queryClient } from '@/lib/react-query';
import reportWebVitals from '@/reportWebVitals';

import { ErrorFallback } from './components';
import { reactPlugin } from './lib/appInsightsManager/AppInsightsManagerSetup';
import { msalInstance } from './lib/react-msal/authConfig';
import { muiGlobalTheme } from './muiGlobalTheme';

if (process.env.NODE_ENV === 'development') {
  Cookies.set('authToken', process.env.REACT_APP_CLIENT1_TOKEN);
}

/**
 * MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders.
 * For more, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */

// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

msalInstance.addEventCallback((event) => {
  if (
    (event.eventType === EventType.LOGIN_SUCCESS ||
      event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
      event.eventType === EventType.SSO_SILENT_SUCCESS) &&
    (event.payload as any).account
  ) {
    msalInstance.setActiveAccount((event.payload as any).account);
  }
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <I18nextProvider i18n={i18next}>
    <ThemeProvider theme={muiGlobalTheme}>
      <QueryClientProvider client={queryClient} contextSharing>
        <ReactQueryDevtools initialIsOpen={false} />
        <AppInsightsContext.Provider value={reactPlugin}>
          <AppInsightsErrorBoundary onError={ErrorFallback} appInsights={reactPlugin}>
            <App instance={msalInstance} />
          </AppInsightsErrorBoundary>
        </AppInsightsContext.Provider>
      </QueryClientProvider>
    </ThemeProvider>
  </I18nextProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
